const localizations = {
    'en': {
        'platform': 'Platform',
        'Group': 'Group',
        'Subgroups': 'Subgroups',
        'Filter': 'Filter',
        'Columns': 'Columns',
        'All': 'All',
        'No instruments to show': 'No instruments to show'
    },
    'ru-ru': {
        'Platform': 'Платформа',
        'Group': 'Группа',
        'Subgroups': 'Подгруппы',
        'Filter': 'Фильтр',
        'Columns': 'Колонки',
        'All': 'Все',
        'No instruments to show': 'Нет инструментов для показа'
    },
    'be-by': {
        'Platform': 'Платформа',
        'Group': 'Группа',
        'Subgroups': 'Подгруппы',
        'Filter': 'Фильтр',
        'Columns': 'Колонки',
        'All': 'Все',
        'No instruments': 'Нет инструментов для показа'
    },
    'zh-cn': {
        'Platform': '交易平台',
        'Group': '分组',
        'Subgroups': '次级分组',
        'Filter': '筛选',
        'Columns': '列',
        'All': '全部',
        'No instruments to show': '未找到相关交易品种'
    }
};

export default function t (str, lang = 'en') {
    return localizations[lang][str] || str;
};



// WEBPACK FOOTER //
// ./src/i18n/index.js